<div class="card">
  <div class="card-header border-0 pt-6">
    <!-- <div class="card-title">
			<div class="d-flex align-items-center position-relative my-1">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input type="text" class="form-control form-control-sm w-250px ps-12" placeholder="Search invoices..." (input)="onSearch($event)" [value]="searchTerm" />
			</div>
		</div> -->
    <div class="card-toolbar flex-row-fluid justify-content-end gap-3">
      <div class="d-inline-flex justify-content-end align-items-center gap-4" data-table-toolbar="base">
        <button type="button" class="btn btn-sm btn-primary me-3 text-nowrap" (click)="exportExcel()" [disabled]="isExportingExcel">
          <span *ngIf="isExportingExcel" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isExportingExcel" class="ki-duotone ki-exit-up fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>{{ isExportingExcel ? 'Exporting...' : 'Export' }}</span>
        </button>
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex" [class.active]="showFilters"
          (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Filter</span>
          <span class="badge badge-circle badge-light-primary ms-2" *ngIf="hasActiveFilters()">
            {{ getActiveFiltersCount() }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFilters" [@slideInOut]>
    <div class="row g-4">
      <!-- Sales Person Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Sales Person</label>
        <div class="position-relative">
          <input type="text" class="form-control form-control-sm" placeholder="Search Sales Person..."
            [(ngModel)]="salesPersonSearchTerm" (input)="onSalesPersonSearchInput($event)"
            (focus)="onSalesPersonInputFocus()" (blur)="onSalesPersonInputBlur()" autocomplete="off" />

          <!-- Clear Button -->
          <button type="button"
            class="btn btn-sm btn-icon btn-light position-absolute top-50 end-0 translate-middle-y me-1"
            *ngIf="selectedSalesPerson || salesPersonSearchTerm" (click)="clearSalesPersonSearch()">
            <i class="ki-duotone ki-cross fs-4">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </button>

          <!-- Dropdown -->
          <div class="dropdown-menu show w-100 p-0" *ngIf="showSalesPersonDropdown"
            style="position: absolute; top: 100%; left: 0; z-index: 1000; max-height: 200px; overflow-y: auto;">

            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isSalesPersonSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching...
            </div>

            <!-- Results -->
            <button type="button" class="dropdown-item py-2" *ngFor="let salesPerson of salesPersonSearchResults"
              (click)="selectSalesPerson(salesPerson)">
              <div class="d-flex align-items-center">
                <div class="symbol symbol-30px me-3">
                  <div class="symbol-label bg-light-primary text-primary fs-7 fw-bold">
                    {{ (salesPerson.name || 'U').charAt(0).toUpperCase() }}
                  </div>
                </div>
                <div class="flex-grow-1">
                  <div class="fw-semibold text-gray-800 fs-7">{{ getSalesPersonDisplayName(salesPerson) }}</div>
                  <div class="text-muted fs-8">{{ salesPerson.email }}</div>
                </div>
              </div>
            </button>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
              *ngIf="!isSalesPersonSearching && salesPersonSearchResults.length === 0">
              No sales persons found
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Search -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Customer</label>
        <div class="position-relative">
          <input type="text" class="form-control form-control-sm" placeholder="Search Customer..."
            [(ngModel)]="customerSearchTerm" (input)="onCustomerSearchInput($event)" (focus)="onCustomerInputFocus()"
            (blur)="onCustomerInputBlur()" autocomplete="off" />

          <!-- Clear Button -->
          <button type="button"
            class="btn btn-sm btn-icon btn-light position-absolute top-50 end-0 translate-middle-y me-1"
            *ngIf="selectedCustomer || customerSearchTerm" (click)="clearCustomerSearch()">
            <i class="ki-duotone ki-cross fs-4">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </button>

          <!-- Dropdown -->
          <div class="dropdown-menu show w-100 p-0" *ngIf="showCustomerDropdown"
            style="position: absolute; top: 100%; left: 0; z-index: 1000; max-height: 200px; overflow-y: auto;">

            <!-- Loading -->
            <div class="dropdown-item text-center py-3" *ngIf="isCustomerSearching">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Searching...
            </div>

            <!-- Results -->
            <button type="button" class="dropdown-item py-2" *ngFor="let customer of customerSearchResults"
              (click)="selectCustomer(customer)">
              <div class="d-flex align-items-center">
                <div class="symbol symbol-30px me-3">
                  <div class="symbol-label bg-light-success text-success fs-7 fw-bold">
                    {{ (customer.name || 'C').charAt(0).toUpperCase() }}
                  </div>
                </div>
                <div class="flex-grow-1">
                  <div class="fw-semibold text-gray-800 fs-7">{{ getCustomerDisplayName(customer) }}</div>
                  <div class="text-muted fs-8">{{ customer.email }}</div>
                </div>
              </div>
            </button>

            <!-- No Results -->
            <div class="dropdown-item text-center py-3 text-muted"
              *ngIf="!isCustomerSearching && customerSearchResults.length === 0">
              No customers found
            </div>
          </div>
        </div>
      </div>

      <!-- Date Range -->
      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Date From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_from">
      </div>

      <div class="col-md-3">
        <label class="form-label fw-semibold text-gray-600 fs-7">Date To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_to">
      </div>
    </div>

    <!-- Status Checkboxes -->
    <div class="row g-4 mt-2">
      <div class="col-12">
        <label class="form-label fw-semibold text-gray-600 fs-7">Vehicle Status</label>
        <div class="d-flex flex-wrap gap-4">
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" [checked]="statusFilters.all"
              (change)="onStatusFilterChange('all', $event)" id="status_all">
            <label class="form-check-label fw-semibold text-gray-700" for="status_all">
              All
            </label>
          </div>
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" [checked]="statusFilters.inJapan"
              (change)="onStatusFilterChange('inJapan', $event)" id="status_in_japan">
            <label class="form-check-label fw-semibold text-gray-700" for="status_in_japan">
              In Japan
            </label>
          </div>
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" [checked]="statusFilters.inTransit"
              (change)="onStatusFilterChange('inTransit', $event)" id="status_in_transit">
            <label class="form-check-label fw-semibold text-gray-700" for="status_in_transit">
              In Transit
            </label>
          </div>
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" [checked]="statusFilters.arrived"
              (change)="onStatusFilterChange('arrived', $event)" id="status_arrived">
            <label class="form-check-label fw-semibold text-gray-700" for="status_arrived">
              Arrived
            </label>
          </div>
          <div class="form-check form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" [checked]="statusFilters.cleared"
              (change)="onStatusFilterChange('cleared', $event)" id="status_cleared">
            <label class="form-check-label fw-semibold text-gray-700" for="status_cleared">
              Cleared
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="d-flex justify-content-end gap-3">
          <button type="button" class="btn btn-sm btn-light" (click)="clearFilters()">
            <i class="ki-duotone ki-cross fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Clear Filters
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
            <i class="ki-duotone ki-magnifier fs-4 me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Invoice Table -->
  <div class="card-body pt-0">
    <div *ngIf="!isLoading && invoices.length > 0" class="sales-table-container">
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 sales-table">
          <thead>
            <tr class="fw-bold text-muted bg-primary-subtle">
              <!-- Sticky Invoice Number Column -->
              <th class="sticky-column min-w-180px">Invoice #</th>
              <!-- Scrollable Columns -->
              <th class="text-nowrap">Agent Name</th>
              <th class="text-nowrap text-center">Status</th>
              <th class="text-nowrap">Stock Number</th>
              <th class="text-nowrap">Age</th>
              <th class="text-nowrap">Chassis #</th>
              <th class="text-nowrap">Model</th>
              <th class="text-nowrap">Year</th>
              <!-- <th class="text-nowrap">Model Code</th> -->
              <th class="text-nowrap">Yard In Date</th>
              <th class="text-nowrap">Yard</th>

              <th class="text-nowrap">Buyer Name</th>
              <th class="text-nowrap">Destination Country</th>
              <th class="text-nowrap">Destination Port</th>
              <th class="text-nowrap">Ship Name</th>
              <th class="text-nowrap">Voyage #</th>

              <th class="text-nowrap">ETD</th>
              <th class="text-nowrap">ETA</th>

              <th class="text-nowrap">Invoice Amount</th>
              <th class="text-nowrap">Allocated Amount</th>
              <th class="text-nowrap">Balance</th>
              <th class="text-nowrap">Currency</th>
              <th class="text-nowrap">Paid(%)</th>
              <th class="text-nowrap">Courier No.</th>
              <th class="text-nowrap">Surrender Date</th>

              <th class="text-nowrap">Stock Url</th>

            <!-- <th class="text-nowrap">Proforma Date</th>
            <th class="text-nowrap">Invoice Date</th>
            <th class="text-nowrap">Broker</th>
            <th class="text-nowrap">Arrival date</th>
            <th class="text-nowrap">Ship Type</th>
            <th class="text-nowrap">CTN Group No.</th>


            <th class="text-nowrap">Yard Name</th>
            <th class="text-nowrap">Courier Date</th>
            <th class="text-nowrap">Re Auction</th>
            <th class="text-nowrap">Invoice Create By</th>
            <th class="text-nowrap">Sales Person</th>
            <th class="text-nowrap">Contract</th>
            <th class="text-nowrap">Contact Info</th> -->
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <!-- Data rows -->
          <tr *ngFor="let invoice of invoices; trackBy: trackByInvoiceId" [class]="getRowColor(invoice)">
            <!-- Sticky Invoice Number Column -->
            <td class="sticky-column">{{ invoice.invoice_number }}</td>
            <!-- Scrollable Columns -->
            <td class="text-nowrap">{{ invoice.order?.sales_person?.name || '-' }}</td>
            <td class="text-nowrap text-center" [attr.data-order]="invoice.status">
              <div class="">
                {{ getStatus(invoice) }}
              </div>
            </td>
            <td class="text-nowrap">{{ invoice.vehicle?.car_no || '-' }}</td>
            <td class="text-nowrap">{{ getAge(invoice) }}</td>
            <td class="text-nowrap">{{ invoice.vehicle?.vin_no || '-' }}</td>
            <td class="text-nowrap">{{ invoice.vehicle?.name || '-' }}</td>
            <td class="text-nowrap">{{ invoice.vehicle?.year || '-' }}</td>

            <td class="text-nowrap">{{ invoice.vehicle.yard_date?formatDate(invoice.vehicle?.yard_date) : '-' }}</td>
            <td class="text-nowrap">{{ invoice.vehicle?.yard_name || '-' }}</td>

            <td class="text-nowrap">{{ invoice.order?.buyer_consignee_name || '-' }}</td>
            <!-- <td class="text-nowrap">{{ invoice.vehicle?.body_type || '-' }}</td> -->
            <td class="text-nowrap">{{ invoice.order?.ship?.destination_country || invoice.order?.from_country || '-' }}
            </td>
            <td class="text-nowrap">{{ invoice.order?.ship?.destination_port || invoice.order?.to_port || '-' }}</td>


            <td class="text-nowrap">{{ invoice.ship?.name || '-' }}</td>
            <td class="text-nowrap">{{ invoice.ship?.voyage_no || '-' }}</td>
            <td class="text-nowrap">{{ invoice.ship?.sailing_date ? formatDate(invoice.ship.sailing_date) : '-' }}</td>
            <td class="text-nowrap">{{ invoice.ship?.arrival_date ? formatDate(invoice.ship.arrival_date) : '-' }}</td>


            <td class="text-nowrap">{{ formatCurrency(invoice.invoice_amount, invoice.item?.currency) }}</td>
            <td class="text-nowrap">{{ formatCurrency(invoice.paid, invoice.item?.currency) }}</td>
            <td class="text-nowrap">{{ formatCurrency(invoice.balance, invoice.item?.currency) }}</td>
            <td class="text-nowrap">{{ invoice.item?.currency == "USD" ? '$' : '¥' }}</td>
            <td class="text-nowrap">{{ calculatePaidPercentage(invoice.paid, invoice.invoice_amount) }}</td>
            <td class="text-nowrap">{{ invoice.courier_no || '-' }}</td>
            <td class="text-nowrap">{{ invoice.surrender_date || '-' }}</td>

            <td class="text-nowrap">
              <a [href]="'http://localhost:8009/api/'+invoice.vehicle?.car_no" target="_blank">Visit Stock</a>
            </td>

            <!-- <td class="text-nowrap">{{ invoice.order?.order_date ? formatDate(invoice.order.order_date) : '-' }}</td>
            <td class="text-nowrap">{{ invoice.invoice_date ? formatDate(invoice.invoice_date) : '-' }}</td>
            <td class="text-nowrap">{{ invoice.created_by?.name || '-' }}</td>
            <td class="text-nowrap">{{ invoice.order?.from_port || '-' }}</td>
            <td class="text-nowrap">{{ invoice.order?.ship_type || '-' }}</td>
            <td class="text-nowrap">{{ invoice.order?.group_no || '-' }}</td>
            <td class="text-nowrap">{{ invoice.yard_name || '-' }}</td>
            <td class="text-nowrap">{{ invoice.courier_date ? formatDate(invoice.courier_date) : '-' }}</td>
            <td class="text-nowrap text-center">
              <div class="badge" [ngClass]="invoice.re_auction ? 'badge-light-success' : 'badge-light-danger'">
                {{ invoice.re_auction ? 'Yes' : 'No' }}
              </div>
            </td>
            <td class="text-nowrap">{{ invoice.created_by?.name || '-' }}</td>
            <td class="text-nowrap">{{ invoice.created_by?.name || '-' }}</td>
            <td class="text-nowrap text-center">
              <div class="badge" [ngClass]="invoice.contract ? 'badge-light-success' : 'badge-light-danger'">
                {{ invoice.contract ? 'Yes' : 'No' }}
              </div>
            </td> -->
            <!-- <td class="text-nowrap text-center">
              <span *ngIf="invoice.con_info; else noContactInfo">
                <i class="ki-duotone ki-information-2 fs-1 text-gray-800">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </i>
              </span>
              <ng-template #noContactInfo>-</ng-template>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Loading state -->
  <div class="card-body pt-0" *ngIf="isLoading">
    <div class="d-flex align-items-center justify-content-center py-10">
      <span class="spinner-border spinner-border-sm me-2"></span>
      Loading invoices...
    </div>
  </div>

  <!-- No data state -->
  <div class="card-body pt-0" *ngIf="!isLoading && invoices.length === 0">
    <div class="text-center py-10 text-muted">
      No invoices found
    </div>
  </div>

  <!-- Pagination Component -->
  <app-pagination *ngIf="!isLoading && invoices.length > 0" [paginationInfo]="paginationInfo" [loading]="isLoading"
    (pageChange)="onPageChange($event)">
  </app-pagination>
</div>
